export const D = {
  maxWidth: '1200px',
  tabletWidth: '900px',
  unit: (n?: number | string | undefined) => n === undefined ? undefined : typeof n === 'string' ? n : `${8 * n}px`,
  radius: (n: number = 1) => `${8 * n}px`,
  interactive: (n: number = 1) => `${36 * n}px`,
};